export default "__VITE_ASSET__GX0nMRA$__"